import $ from "jquery";
import Em from "./Em";

class Header extends Em {
	constructor() {
		super();
		if (!this.selfDom()) return;

		this.events();
	}

	selfDom() {
		this.$headerNavToggle = this.$header.find('.header-nav-toggle');

		this.$headerNav = this.$header.find('#primary-nav > ul');
		this.$headerNavItems = this.$headerNav.find('li.menu-item-has-children');
		this.$headerNavItemsToggle = this.$headerNavItems.find('> a');

		return true;
	}

	events() {
		// toggle mobile nav
		this.$headerNavToggle.off('click.Header');
		this.$headerNavToggle.on('click.Header', this.toggleNavHandler.bind(this));

		// toggle subnav - click
		this.$headerNavItemsToggle.off('click.Header');
		this.$headerNavItemsToggle.on('click.Header', this.toggleSubnavHandler.bind(this));

		// open subnav - hover
		this.$headerNavItems.off('mouseenter.Header');
		this.$headerNavItems.on('mouseenter.Header', this.openSubMenuHandler.bind(this));

		// close subnav - hover
		this.$headerNavItems.off('mouseleave.Header');
		this.$headerNavItems.on('mouseleave.Header', this.closeSubMenuHandler.bind(this));

		// sticky header
		this.$window.off('scroll.Header');
		this.$window.on('scroll.Header', () => {
			const position = this.$window.scrollTop();
			const startPosition = 0;
			
			if (position > startPosition) {
				this.$body.addClass('header-sticky');
				this.$header.css('top', this.$body.offset().top);
			} else {
				this.$body.removeClass('header-sticky');
				this.$header.css('top', '');
			}
		});
	}

	openSubMenuHandler(event) {
		if (this.isMobileMenu()) return;

		const $item = $(event.currentTarget);

		this.$headerNavItems.removeClass('is-hover');
		$item.addClass('is-hover');
	}

	closeSubMenuHandler(event) {
		if (this.isMobileMenu()) return;

		this.$headerNavItems.removeClass('is-hover');
	}

	toggleNavHandler(event) {
		event.preventDefault();

		if (!this.$headerNav.hasClass('is-visible')) {
			this.$header.addClass('is-nav-visible');
			this.$headerNav.addClass('is-visible');
		} else {
			this.$header.removeClass('is-nav-visible');
			this.$headerNav.removeClass('is-visible');
			this.$headerNavItems.removeClass('is-active')
		}

		return false;
	}

	toggleSubnavHandler(event) {
		if(this.isMobileMenu()) {
			event.preventDefault();

			const $item = $(event.currentTarget).closest(this.$headerNavItems);
	
			if (!$item.hasClass('is-active')) {
				$item.addClass('is-active');
			} else {
				$item.removeClass('is-active');
			}

			return false;
		}
	}

	isMobileMenu() {
		return this.$headerNavToggle.is(':visible');
	}
}

export default Header;
